/* eslint-disable prettier/prettier */
/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import CustomPagination from "../../../shared/customPagination/CustomPagination1";
import { UIContext, AuthContext, GroupContext } from "../../../../contexts";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";

import { Pagination } from "@material-ui/lab";
import { Button, CircularProgress, useMediaQuery } from "@material-ui/core";

import GroupAddIcon from "@material-ui/icons/GroupAdd";
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./members.css";
import ExtractRouteParams from "../../../../utils/commonFunctions/extractRouteParams";
import { PaginationQuery, PaginationTypes } from "../../../../@types/pagination.types";
import getLimit from "../../../../utils/pagination/getLimit";
import encryption from "../../../../utils/commonFunctions/encryption";
import ROLES from "../../../../constants/roles";
import initCapitalize from "../../../../utils/commonFunctions/initCapitalize";
import { api } from "../../../../utils/api";
import useRouteParam from "../../../../hooks/useRouteParam";
import { AssignedPaginatedMembers } from "../../../../@types/api/admin/user/user.types";
import { Member } from "../../../../@types/member.types";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";
import { trackPromise } from "react-promise-tracker";
import { useEnroller } from "../../../../hooks";
import { handleMemberIdCellRenderer, handleValueCellRenderer } from "../../../../utils/commonFunctions/cellRenderers";
import { CustomFloatingFilter } from "../../../shared";
import { CustomFilter } from "../../../shared";
import { UIFormatSSN } from "../../../../utils/commonFunctions/SSN";
import { GROUP_NUMBER } from "../../../../constants/groups";
import CircularLoader from "../../../shared/loader/CircularLoader";
import { FaEye, FaEyeSlash } from "react-icons/fa";
const GroupMembers = (): JSX.Element => {
	const { isEnroller } = useEnroller();
	const [members, setMembers] = useState<Member[]>([]);
	const [loading, setLoading] = useState(true);
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);
	const [isRowSelected, setIsRowSelected] = useState(false);
	const [selectedRowData, setSelectedRowData] = useState([]);
	const { setDashboardHeader } = useContext(UIContext);
	const { user } = useContext(AuthContext);
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const navigate = useNavigate();
	const [limit, setLimit] = useState<number | null>(null);
	const [ssnVisibility, setSsnVisibility] = useState(false);
	const { currentGroup, setCurrentGroup } = useContext(GroupContext);
	const [paginationFirstRender, setPaginationFirstRender] = useState(true);
	const [pagination, setPagination] = useState<PaginationTypes>({
		currentPage: 1,
		pageCount: undefined
	});
	const [groupMembersFilterSchema, setGroupMembersFilterSchema] = useState({
		member_id: {
			value: null,
			type: null
		},
		first_name: {
			value: null,
			type: null
		},
		last_name: {
			value: null,
			type: null
		},
		ssn: {
			value: null,
			type: null
		},
		role: {
			value: null,
			type: null
		}
	});
	const { currentPage, pageCount } = pagination;
	const xl = useMediaQuery("(min-width:1600px)");
	const lg = useMediaQuery("(min-width:1200px)");
	const md = useMediaQuery("(min-width:800px)");
	const sm = useMediaQuery("(min-width:600px)");
	const xs = useMediaQuery("(min-width:400px)");

	const _limit = useMemo(() => getLimit(xl, lg, md, sm, xs), [lg, md, sm, xl, xs]);

	// console.log("LIMIT_PAGE", _limit);
	// const _limit = getLimit(xl, lg, md, sm, xs);
	const queryGroupNumber = useRouteParam("gn");

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleViewMembersDetails = () => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		// console.log("Row", row);
		const {
			data: { role, group_number, SSN, employee_SSN }
		} = row;

		if (role === ROLES.employee) navigate(`/employer/member?gn=${group_number}&&qs=${encryption(SSN) as string}`);
		else if (role === ROLES.dependent)
			navigate(
				`/employer/member/dependent?gn=${group_number}&&qs=${encryption(SSN) as string}&&qe=${
					encryption(employee_SSN) as string
				}`
			);
	};

	const handleActionDetailsButtonRender = () => {
		return (
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				onClick={handleViewMembersDetails}
				style={{ marginTop: "3px", marginBottom: "6px" }}
			>
				See Details
			</Button>
		);
	};

	// const handleActionHistoryButtonRender = useCallback(() => {
	//  return (
	//      <Button className="ag-grid-cell-button button-black" variant="outlined" onClick={handleNewPageChange}>
	//          Move to History
	//      </Button>
	//  );
	// }, [handleNewPageChange]);

	const handleAddEmployeeClick = useCallback(() => {
		const pathname = `/employer/members/create-employee?${routeParam}`;
		navigate(pathname);
	}, [navigate, routeParam]);

	const handleBulkUploadClick = useCallback(() => {
		const pathname = `/employer/members/bulk-upload?${routeParam}`;
		navigate(pathname);
	}, [navigate, routeParam]);

	const handleVEBTerminationBulkUploadClick = useCallback(() => {
		const pathname = `/employer/members/bulk-upload/VEB-termination?${routeParam}`;
		navigate(pathname);
	}, [navigate, routeParam]);

	const handlePageChange = useCallback(
		(event: React.ChangeEvent<unknown>, page: number) => {
			setPagination(
				Object.assign({}, pagination, {
					currentPage: page
				})
			);
		},
		[pagination]
	);

	const handleDateCellRenderer = ({ value }: { value: string }) => dateTimeZoneConverter(value);

	const HandleSSNCellRenderer = ({ value, data }: { value: string; data: any }) => {
		const [isVisible, setIsVisible] = useState(false);
		const { user } = useContext(AuthContext);
		const ssn = value ? value.substring(0, 3) + "-" + value.substring(3, 5) + "-" + value.substring(5) : "";
		const SSN = UIFormatSSN(ssn);
		const formatSSN = (ssn: string, visible = false) => {
			if (!ssn) return "";
			if (visible) return ssn;
			const sanitizedSSN = SSN.endsWith("@") ? SSN.slice(0, -1) : SSN;
			const lastFour = sanitizedSSN.slice(-4);
			return `XXX-XX-${lastFour}`;
		};
		const handleToggleVisibility = async (e: React.MouseEvent) => {
			// console.log("Toggle visibility clicked");
			e.stopPropagation();

			if (!isVisible) {
				try {
					// console.log("Attempting to log SSN view...");
					const viewSSNAddLogPayload = {
						member_id: data._id,
						member_role: data.role
					};
					const response = await api.viewSSNLog.viewSSNAddLog(viewSSNAddLogPayload);
					// console.log("SSN view log response:", response);
				} catch (error) {
					console.error("Error logging SSN view:", error);
					return;
				}
			}
			setIsVisible(!isVisible);
		};

		const shouldShowFullSSN =
			user &&
			user?.role === ROLES.super_admin &&
			((user?.first_name === "Chitrak" && user?.last_name === "Biswas") ||
				(user?.first_name === "Anupam" && user?.last_name === "Biswas") ||
				(user?.first_name === "Rahul" && user?.last_name === "Dutta") ||
				(user?.first_name === "Suman" && user?.last_name === "Dutta"));

		const displayedSSN = isVisible ? SSN : formatSSN(SSN);

		return (
			<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
				<span>{displayedSSN}</span>
				<button
					onClick={(e) => handleToggleVisibility(e)}
					style={{
						background: "none",
						border: "none",
						cursor: "pointer",
						padding: 0,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						fontSize: "20px",
						lineHeight: 1,
						color: "green"
					}}
					title={isVisible ? "Hide SSN" : "Show SSN"}
				>
					{isVisible ? <FaEye /> : <FaEyeSlash />}
				</button>
			</div>
		);
	};

	const handleUserRoleCellRenderer = ({ value }: { value: string }) => {
		const role = initCapitalize(value as string);
		return <div>{role}</div>;
	};

	const handleRegisteredMemberCellRenderer = ({ value }: { value: boolean }) => {
		return <div>{value ? "Yes" : "No"}</div>;
	};

	const getMemberCountOfParticularGroup = useCallback(async () => {
		try {
			if (limit) {
				// console.log("debug-count", queryGroupNumber);
				const memberCount = await api.user.getMemberCountOfParticularGroup(queryGroupNumber as number);
				const pageCount = Math.ceil(memberCount / limit);
				// console.log("pageCount", pageCount);
				setPagination(Object.assign({}, pagination, { pageCount }));
			}
		} catch (error) {
			console.log(error);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [limit, queryGroupNumber]);

	const getPaginatedMembersByGroupAndAssignedLocation = useCallback(async () => {
		// console.log("running");
		if (typeof limit === "number" && typeof pagination.currentPage === "number") {
			// console.log("running 2");
			setLoading(true);
			let paginationQuery: PaginationQuery = {
				limit: limit,
				page: pagination.currentPage
			};
			Object.entries(groupMembersFilterSchema).map(([key, value]) => {
				if (value.value !== "" && value.value !== null) {
					paginationQuery = {
						...paginationQuery,
						[key]: key === "role" ? (value.value as string).toUpperCase() : value.value
					};
				}
			});
			try {
				const assignedPaginatedMembers: AssignedPaginatedMembers = await trackPromise(
					api.user.getPaginatedMembersByGroupAndAssignedLocation(paginationQuery, queryGroupNumber as number)
				);
				// console.log("RESPONSEFORCHEKING---->", assignedPaginatedMembers);
				setMembers(Object.assign([], assignedPaginatedMembers.members));
				const pageCount = Math.ceil(assignedPaginatedMembers.totalDocuments / limit);
				// console.log("pageCount", pageCount);
				setPagination((prev: any) => {
					return { ...prev, pageCount: pageCount };
				});
			} catch (error) {
				setMembers(Object.assign([], []));
				setPagination((prev: any) => {
					return { ...prev, pageCount: 0 };
				});
				// console.log("error", error);
			} finally {
				setLoading(false);
			}
		}
		// const paginationQuery: PaginationQuery = {
		//  limit: 30000,
		//  page: 1
		// };
		// const assignedPaginatedMembers: AssignedPaginatedMembers = await trackPromise(
		//  api.user.getPaginatedMembersByGroupAndAssignedLocation(paginationQuery, queryGroupNumber as number)
		// );
		// setMembers(Object.assign([], assignedPaginatedMembers.members));
	}, [limit, pagination.currentPage, groupMembersFilterSchema, queryGroupNumber]);

	useEffect(() => {
		setLimit(_limit);
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.all_members);
	}, [_limit, setDashboardHeader]);

	useEffect(() => {
		if (queryGroupNumber) getMemberCountOfParticularGroup();
	}, [getMemberCountOfParticularGroup, queryGroupNumber]);

	useEffect(() => {
		if (queryGroupNumber && limit && (pagination.pageCount == 0 || pagination.pageCount) && paginationFirstRender) {
			getPaginatedMembersByGroupAndAssignedLocation();
			setDashboardHeader(ADMIN_DASHBOARD_HEADER.all_members);
			setPaginationFirstRender(false);
		}
	}, [
		setDashboardHeader,
		queryGroupNumber,
		pagination,
		limit,
		getPaginatedMembersByGroupAndAssignedLocation,

		paginationFirstRender
	]);

	useEffect(() => {
		if (queryGroupNumber && limit && !paginationFirstRender) {
			getPaginatedMembersByGroupAndAssignedLocation();
		}
	}, [
		groupMembersFilterSchema,
		limit,
		queryGroupNumber,
		getPaginatedMembersByGroupAndAssignedLocation,
		paginationFirstRender
	]);

	useEffect(() => {
		if (queryGroupNumber) {
			const fetchGroup = async () => {
				try {
					const group = await api.group.getGroupByGroupNumber(queryGroupNumber as number);
					setCurrentGroup(group);
				} catch (error) {
					console.error("Error fetching group:", error);
				}
			};

			fetchGroup();
		}
	}, [queryGroupNumber, setCurrentGroup]);

	// useEffect(() => {
	//  if (queryGroupNumber) {
	//      getPaginatedMembersByGroupAndAssignedLocation();
	//      setDashboardHeader(ADMIN_DASHBOARD_HEADER.all_members);
	//  }
	// }, [getPaginatedMembersByGroupAndAssignedLocation, queryGroupNumber, setDashboardHeader]);

	// useEffect(() => {
	//  //console.log("groupMembersFilterSchema", groupMembersFilterSchema);
	//  let filterEmpty = true;
	//  setIsFilterEmpty(true);
	//  Object.entries(groupMembersFilterSchema).map(([key, value]) => {
	//      if (value.value != "" && value.value != null) {
	//          setIsFilterEmpty(false);
	//          filterEmpty = false;
	//      }
	//  });
	//  if (!filterEmpty) {
	//      console.log(groupMembersFilterSchema);
	//  }
	// }, [groupMembersFilterSchema]);

	const functionToBePassed = () => {
		// console.log("functionToBePassed");
	};

	// console.log("currentGroup=====>", currentGroup);

	return (
		<>
			<div className="all-member-page-container">
				{isEnroller ? null : (
					<div className="pf-action-button-container" id="pf-action-button-container">
						{/* <Button className="button-green" variant="contained" onClick={handleVEBTerminationBulkUploadClick}>
                        <span className="button-label-with-icon">VEB Termination Upload</span>
                        <span>
                            <OpenInBrowserIcon className="button-icon" />
                        </span>
                    </Button> */}
						{queryGroupNumber !== GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS ? (
							<Button
								className="button-green"
								variant="contained"
								onClick={handleVEBTerminationBulkUploadClick}
							>
								<span className="button-label-with-icon">VEB Termination Upload</span>
								<span>
									<OpenInBrowserIcon className="button-icon" />
								</span>
							</Button>
						) : null}
						<Button className="button-black" variant="contained" onClick={handleBulkUploadClick}>
							<span className="button-label-with-icon">Member Bulk Upload</span>
							<span>
								<OpenInBrowserIcon className="button-icon" />
							</span>
						</Button>
						<Button className="button-green" variant="contained" onClick={handleAddEmployeeClick}>
							<span className="button-label-with-icon">Add Employee</span>
							<span>
								<GroupAddIcon className="button-icon" />
							</span>
						</Button>
					</div>
				)}
				<div className="all-members-grid-container">
					{loading && <CircularLoader />}
					<div className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
						<AgGridReact
							ref={agGridRef}
							rowData={members}
							onGridReady={handleAgGridReady}
							onFirstDataRendered={handleFirstDataRendered}
							rowSelection={"Single"}
							animateRows
							suppressColumnVirtualisation={true}
							defaultColDef={{
								filter: "agTextColumnFilter",
								floatingFilter: true,
								resizable: true
							}}
							enableCellChangeFlash={true}
							defaultColGroupDef={{ marryChildren: true }}
							frameworkComponents={{
								handleActionDetailsButtonRender: handleActionDetailsButtonRender,
								handleDateCellRenderer: handleDateCellRenderer,
								handleSSNCellRenderer: HandleSSNCellRenderer,
								handleUserRoleCellRenderer: handleUserRoleCellRenderer,
								handleRegisteredMemberCellRenderer: handleRegisteredMemberCellRenderer,
								handleValueCellRenderer: handleValueCellRenderer,
								handleMemberIdCellRenderer: handleMemberIdCellRenderer,
								customFloatingFilter: CustomFloatingFilter,
								customFilter: CustomFilter,
								schema: groupMembersFilterSchema,
								setPayloadSchema: setGroupMembersFilterSchema,
								functionToBePassed: functionToBePassed,
								setParentSchema: setMembers
							}}
						>
							{user &&
							user.role === ROLES.super_admin &&
							((user.first_name === "Chitrak" && user.last_name === "Biswas") ||
								(user.first_name === "Anupam" && user.last_name === "Biswas") ||
								(user.first_name === "Rahul" && user.last_name === "Dutta") ||
								(user.first_name === "Suman" && user.last_name === "Dutta")) ? (
								<AgGridColumn
									field="group_number"
									headerName="Group Number"
									floatingFilterComponentParams={{ suppressFilterButton: true }}
									suppressSizeToFit
									filter={false}
								></AgGridColumn>
							) : null}
							<AgGridColumn
								field="member_id"
								headerName="Member Id"
								// checkboxSelection={true}
								//floatingFilterComponentParams={{ suppressFilterButton: true }}
								cellRenderer="handleMemberIdCellRenderer"
								// floatingFilterComponentParams={{
								//  suppressFilterButton: true
								// }}
								suppressSizeToFit
								floatingFilterComponent="customFloatingFilter"
								filter="customFilter"
							></AgGridColumn>
							<AgGridColumn
								field="first_name"
								headerName="First Name"
								suppressSizeToFit
								onCellClicked={handleViewMembersDetails}
								cellStyle={() => {
									return { cursor: "pointer" };
								}}
								//floatingFilterComponentParams={{ suppressFilterButton: true }}
								// floatingFilterComponentParams={{
								//  suppressFilterButton: true
								// }}
								floatingFilterComponent="customFloatingFilter"
								filter="customFilter"
							></AgGridColumn>
							<AgGridColumn
								field="last_name"
								headerName="Last name"
								suppressSizeToFit
								//floatingFilterComponentParams={{ suppressFilterButton: true }}
								floatingFilterComponent="customFloatingFilter"
								onCellClicked={handleViewMembersDetails}
								cellStyle={() => {
									return { cursor: "pointer" };
								}}
								filter="customFilter"
							></AgGridColumn>
							<AgGridColumn
								field="date_of_birth"
								headerName="Date Of Birth"
								suppressSizeToFit
								//floatingFilterComponentParams={{ suppressFilterButton: true }}
								cellRenderer="handleDateCellRenderer"
								filter={false}
							></AgGridColumn>
							<AgGridColumn
								field="SSN"
								// headerName="ALT-ID"
								// headerName="SSN"
								headerName={currentGroup?.SSN_provided_by_group ? "SSN" : "ALT-ID"}
								suppressSizeToFit
								//floatingFilterComponentParams={{ suppressFilterButton: true }}
								cellRenderer="handleSSNCellRenderer"
								floatingFilterComponent="customFloatingFilter"
								filter="customFilter"
								onCellClicked={handleViewMembersDetails}
								cellStyle={() => {
									return { cursor: "pointer" };
								}}
							></AgGridColumn>
							<AgGridColumn
								field="is_registered"
								headerName="Registered Member"
								suppressSizeToFit
								//floatingFilterComponentParams={{ suppressFilterButton: true }}
								cellRenderer="handleRegisteredMemberCellRenderer"
								filter={false}
							></AgGridColumn>
							<AgGridColumn
								field="role"
								headerName="Role"
								suppressSizeToFit
								//floatingFilterComponentParams={{ suppressFilterButton: true }}
								cellRenderer="handleUserRoleCellRenderer"
								floatingFilterComponent="customFloatingFilter"
								filter="customFilter"
							></AgGridColumn>
							<AgGridColumn
								field="action"
								headerName="See Details"
								cellRenderer="handleActionDetailsButtonRender"
								suppressSizeToFit={true}
								filter={false}
							></AgGridColumn>
						</AgGridReact>
					</div>
				</div>
				<div className="custom-pagination" id="custom-pagination">
					<CustomPagination
						pageCount={pageCount}
						currentPage={currentPage}
						handlePageChange={handlePageChange}
					/>
				</div>
			</div>
		</>
	);
};

export default GroupMembers;
